<template>
  <div class="account-list md-layout md-alignment-top-center">
    <md-progress-bar v-show="accountsLoading" class="md-accent md-layout-item md-size-100" md-mode="indeterminate"></md-progress-bar>
    <account-table :accounts-loading="accountsLoading" :accounts="accounts"></account-table>
    <md-button to="/new-account" class="md-primary md-fab md-fixed md-fab-bottom-right">
      <md-tooltip md-direction="top">Add Account</md-tooltip>
      <md-icon>add</md-icon>
    </md-button>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';
import AccountTable from '@/components/AccountTable.vue';
export default {
  name: "accountList",
  components: {AccountTable},
  computed: {
    ...mapGetters(['accounts', 'accountsLoading']),
  },

};
</script>

<style lang="scss" scoped>
  .md-field {
    max-width: 300px;
  }
 
</style>